<div class="aplicacoes-historicos width-100 double-nav-bar" ng-if="appWrap.open">
  <uib-tabset active="appWrap.activeTab" class="tabset">

    <!-- Pulverizações -->
    <uib-tab heading="Pulverizações" index="'pulverizacao'" select="appWrap.activate('pulverizacao')" deselect="appWrap.deactivate('pulverizacao')" disable="appWrap.disabled.pulverizacao || disableInHistory()">
      <div ng-controller="HistoricoAplicacoesCtrl">
        <div class="container-header">
          <div class="clearfix"></div>

          <div class="title text-center">
            <h2>
              <strong>PULVERIZAÇÕES</strong>
            </h2>
          </div>
          <!-- Filtros -->
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(applicationsFilters.gleba.descricao || 'Talhão') | capitalize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="applicationsFilters.gleba">
                <a ng-click="setFilterAttribute('gleba', null, $event)" href="#">Todas</a>
              </li>
              <li role="menuitem" ng-repeat="gleba in glebas | orderBy:'descricao' track by gleba.id">
                <a ng-click="setFilterAttribute('gleba', gleba, $event)" href="#">{{::gleba.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{period.periodo || 'Período'}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-repeat="periodo in filtroPeriodo">
                <a ng-click="setPeriodo(periodo, $event)" href="#">{{::periodo.descricao | capitalize}}</a>
              </li>
              <li role="menuitem">
                <a ng-click="openPeriodsFilter($event)" href="#">Customizado</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-show="culturas.length || sharedData.culturas.length">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(applicationsFilters.cultura.descricao || 'Cultura') | capitalize}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="applicationsFilters.cultura">
                <a ng-click="setFilterAttribute('cultura', null, $event)" href="#">Todas</a>
              </li>
              <li role="menuitem" ng-repeat="cultura in (culturas || sharedData.culturas) track by cultura.id">
                <a ng-click="setFilterAttribute('cultura', cultura, $event)" href="#">{{::cultura.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-if="exibirPainelErrosIntegracao">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{getStatusFilterLabel()}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right status-filter-menu" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.integrado}">
                <a ng-click="toggleStatusFilter('integrado', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.integrado ? 'fa-check-square-o' : 'fa-square-o'"></i> Integrados
                </a>
              </li>
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.erro}">
                <a ng-click="toggleStatusFilter('erro', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.erro ? 'fa-check-square-o' : 'fa-square-o'"></i> Erro
                </a>
              </li>
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.pendente}">
                <a ng-click="toggleStatusFilter('pendente', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.pendente ? 'fa-check-square-o' : 'fa-square-o'"></i> Pendentes
                </a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-show="epocas.length">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(applicationsFilters.epoca.descricao || 'Período agrícola') | capitalize}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="applicationsFilters.epoca">
                <a ng-click="setFilterAttribute('epoca', null, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="epoca in epocas track by epoca.codigo">
                <a ng-click="setFilterAttribute('epoca', epoca, $event)" href="#">{{::epoca.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" ng-show="loadingEstadio">
            <span>
              <i class="pull-right fa fa-spinner fa-spin"></i>
            </span>
          </div>
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle
               ng-show="!loadingEstadio && applicationsFilters.cultura && estadios.length">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(applicationsFilters.estadio.descricao || 'Estádio') | capitalize | characters:12}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="applicationsFilters.estadio">
                <a ng-click="setFilterAttribute('estadio', null, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="estadio in estadios track by estadio.id">
                <a ng-click="setFilterAttribute('estadio', estadio, $event)" href="#">{{::estadio.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" ng-show="loadingGrupoInsumo">
            <span>
              <i class="pull-right fa fa-spinner fa-spin"></i>
            </span>
          </div>
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-show="!loadingGrupoInsumo">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{applicationsFilters.grupoInsumo.descricao || 'Grupo de Insumo' | capitalize | characters:15}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="applicationsFilters.grupoInsumo">
                <a ng-click="setFilterAttribute('grupoInsumo', null, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="grupoInsumo in filtroGruposInsumos track by $index">
                <a ng-click="setFilterAttribute('grupoInsumo', grupoInsumo, $event)" href="#">{{grupoInsumo.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

        <!-- Fim Filtros -->
        </div>

        <div class="container-body width-100" ng-include="'views/painel_propriedade/_accordion_pulverizacao.html'"></div>
      </div>
    </uib-tab>

    <!-- Plantios -->
    <uib-tab heading="Plantio" index="'plantio'" select="appWrap.activate('plantio')" deselect="appWrap.deactivate('plantio')" disable="appWrap.disabled.plantio || disableInHistory()">
      <div ng-controller="HistoricoPlantiosCtrl">
        <div class="container-header">
          <div class="clearfix"></div>

          <div class="title text-center">
            <h2>
              <strong>PLANTIO</strong>
            </h2>
          </div>
          <!-- Filtros -->
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(plantiosFilters.gleba.descricao || 'Talhão') | capitalize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()" >
              <li role="menuitem" ng-show="plantiosFilters.gleba">
                <a ng-click="setFilterAttribute('gleba', null, $event)" href="#">Todas</a>
              </li>
              <li role="menuitem" ng-repeat="gleba in glebas | orderBy:'descricao' track by gleba.id">
                <a ng-click="setFilterAttribute('gleba', gleba, $event)" href="#">{{::gleba.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{period.periodo || 'Período'}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()" >
              <li role="menuitem" ng-repeat="periodo in filtroPeriodo">
                <a ng-click="setPeriodo(periodo, $event)" href="#">{{::periodo.descricao | capitalize}}</a>
              </li>
              <li role="menuitem">
                <a ng-click="openPeriodsFilter($event)" href="#">Customizado</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-show="culturas.length">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(plantiosFilters.cultura.descricao || 'Cultura') | capitalize}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()" >
              <li role="menuitem" ng-show="plantiosFilters.cultura">
                <a ng-click="setFilterAttribute('cultura', null, $event)" href="#">Todas</a>
              </li>
              <li role="menuitem" ng-repeat="cultura in culturas track by cultura.id">
                <a ng-click="setFilterAttribute('cultura', cultura, $event)" href="#">{{::cultura.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-if="exibirPainelErrosIntegracao">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{getStatusFilterLabel()}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right status-filter-menu" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.integrado}">
                <a ng-click="toggleStatusFilter('integrado', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.integrado ? 'fa-check-square-o' : 'fa-square-o'"></i> Integrados
                </a>
              </li>
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.erro}">
                <a ng-click="toggleStatusFilter('erro', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.erro ? 'fa-check-square-o' : 'fa-square-o'"></i> Erro
                </a>
              </li>
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.pendente}">
                <a ng-click="toggleStatusFilter('pendente', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.pendente ? 'fa-check-square-o' : 'fa-square-o'"></i> Pendentes
                </a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-show="epocas.length">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(plantiosFilters.epoca.descricao || 'Período agrícola') | capitalize}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()" >
              <li role="menuitem" ng-show="plantiosFilters.epoca">
                <a ng-click="setFilterAttribute('epoca', null, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="epoca in epocas track by epoca.codigo">
                <a ng-click="setFilterAttribute('epoca', epoca, $event)" href="#">{{::epoca.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" ng-show="loadingEstadio">
            <span>
              <i class="pull-right fa fa-spinner fa-spin"></i>
            </span>
          </div>
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle
               ng-show="!loadingEstadio && plantiosFilters.cultura && estadios.length">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(plantiosFilters.estadio.descricao || 'Estádio') | capitalize | characters:12}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()" >
              <li role="menuitem" ng-show="plantiosFilters.estadio">
                <a ng-click="setFilterAttribute('estadio', null, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="estadio in estadios track by estadio.id">
                <a ng-click="setFilterAttribute('estadio', estadio, $event)" href="#">{{::estadio.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

        <!-- Fim Filtros -->
        </div>

        <div class="container-body width-100" ng-include="'views/painel_propriedade/_accordion_pulverizacao.html'"></div>
      </div>
    </uib-tab>

    <!-- Correções de solo -->
    <uib-tab heading="Correção de solo" index="'correcaoSolo'" select="appWrap.activate('correcaoSolo')" deselect="appWrap.deactivate('correcaoSolo')" disable="appWrap.disabled.correcaoSolo || disableInHistory()">
      <div ng-controller="HistoricoCorrecaoSoloCtrl">
        <div class="container-header">
          <div class="clearfix"></div>

          <div class="title text-center">
            <h2>
              <strong>CORREÇÃO DE SOLO</strong>
            </h2>
          </div>
          <!-- Filtros -->
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(correcoesFilters.gleba.descricao || 'Talhão') | capitalize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="correcoesFilters.gleba">
                <a ng-click="setFilterAttribute('gleba', null, $event)" href="#">Todas</a>
              </li>
              <li role="menuitem" ng-repeat="gleba in glebas | orderBy:'descricao' track by gleba.id">
                <a ng-click="setFilterAttribute('gleba', gleba, $event)" href="#">{{::gleba.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{period.periodo || 'Período'}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-repeat="periodo in filtroPeriodo">
                <a ng-click="setPeriodo(periodo, $event)" href="#">{{::periodo.descricao | capitalize}}</a>
              </li>
              <li role="menuitem">
                <a ng-click="openPeriodsFilter($event)">Customizado</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-show="epocas.length">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(correcoesFilters.epoca.descricao || 'Período agrícola') | capitalize}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="correcoesFilters.epoca">
                <a ng-click="setFilterAttribute('epoca', null, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="epoca in epocas track by epoca.codigo">
                <a ng-click="setFilterAttribute('epoca', epoca, $event)" href="#">{{::epoca.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" ng-show="loadingEstadio">
            <span>
              <i class="pull-right fa fa-spinner fa-spin"></i>
            </span>
          </div>
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle
               ng-show="!loadingEstadio && correcoesFilters.cultura && estadios.length">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(correcoesFilters.estadio.descricao || 'Estádio') | capitalize | characters:12}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="correcoesFilters.estadio">
                <a ng-click="setFilterAttribute('estadio', null, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="estadio in estadios track by estadio.id">
                <a ng-click="setFilterAttribute('estadio', estadio, $event)" href="#">{{::estadio.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-if="exibirPainelErrosIntegracao">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{getStatusFilterLabel()}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right status-filter-menu" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.integrado}">
                <a ng-click="toggleStatusFilter('integrado', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.integrado ? 'fa-check-square-o' : 'fa-square-o'"></i> Integrados
                </a>
              </li>
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.erro}">
                <a ng-click="toggleStatusFilter('erro', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.erro ? 'fa-check-square-o' : 'fa-square-o'"></i> Erro
                </a>
              </li>
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.pendente}">
                <a ng-click="toggleStatusFilter('pendente', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.pendente ? 'fa-check-square-o' : 'fa-square-o'"></i> Pendentes
                </a>
              </li>
            </ul>
          </div>

        <!-- Fim Filtros -->
        </div>

        <div class="container-body width-100" ng-include="'views/painel_propriedade/_accordion_pulverizacao.html'"></div>
      </div>
    </uib-tab>

    <!-- Adubações -->
    <uib-tab heading="Adubação" index="'adubacao'" select="appWrap.activate('adubacao')" deselect="appWrap.deactivate('adubacao')" disable="appWrap.disabled.adubacao || disableInHistory()">
      <div ng-controller="HistoricoAdubacaoCtrl">
        <div class="container-header">
          <div class="clearfix"></div>

          <div class="title text-center">
            <h2>
              <strong>ADUBAÇÃO</strong>
            </h2>
          </div>
          <!-- Filtros -->
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(adubacoesFilters.gleba.descricao || 'Talhão') | capitalize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="adubacoesFilters.gleba">
                <a ng-click="setFilterAttribute('gleba', null, $event)" href="#">Todas</a>
              </li>
              <li role="menuitem" ng-repeat="gleba in glebas | orderBy:'descricao' track by gleba.id">
                <a ng-click="setFilterAttribute('gleba', gleba, $event)" href="#">{{::gleba.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{period.periodo || 'Período'}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-repeat="periodo in filtroPeriodo">
                <a ng-click="setPeriodo(periodo, $event)" href="#">{{::periodo.descricao | capitalize}}</a>
              </li>
              <li role="menuitem">
                <a ng-click="openPeriodsFilter($event)" href="#">Customizado</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-show="epocas.length">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(adubacoesFilters.epoca.descricao || 'Período agrícola') | capitalize}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="adubacoesFilters.epoca">
                <a ng-click="setFilterAttribute('epoca', null, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="epoca in epocas track by epoca.codigo">
                <a ng-click="setFilterAttribute('epoca', epoca, $event)" href="#">{{::epoca.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" ng-show="loadingEstadio">
            <span>
              <i class="pull-right fa fa-spinner fa-spin"></i>
            </span>
          </div>
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle
               ng-show="!loadingEstadio && adubacoesFilters.cultura && estadios.length">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{(adubacoesFilters.estadio.descricao || 'Estádio') | capitalize | characters:12}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="adubacoesFilters.estadio">
                <a ng-click="setFilterAttribute('estadio', null, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="estadio in estadios track by estadio.id">
                <a ng-click="setFilterAttribute('estadio', estadio, $event)" href="#">{{::estadio.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-if="exibirPainelErrosIntegracao">
            <button type="button" class="btn" ng-disabled="disableInHistory()">
               {{getStatusFilterLabel()}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right status-filter-menu" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.integrado}">
                <a ng-click="toggleStatusFilter('integrado', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.integrado ? 'fa-check-square-o' : 'fa-square-o'"></i> Integrados
                </a>
              </li>
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.erro}">
                <a ng-click="toggleStatusFilter('erro', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.erro ? 'fa-check-square-o' : 'fa-square-o'"></i> Erro
                </a>
              </li>
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.pendente}">
                <a ng-click="toggleStatusFilter('pendente', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.pendente ? 'fa-check-square-o' : 'fa-square-o'"></i> Pendentes
                </a>
              </li>
            </ul>
          </div>

        <!-- Fim Filtros -->
        </div>

        <div class="container-body width-100" ng-include="'views/painel_propriedade/_accordion_pulverizacao.html'"></div>
      </div>
    </uib-tab>

    <!-- Tratamentos de semente -->
    <uib-tab heading="Tratamento de Sementes" index="'ts'" select="appWrap.activate('ts')" deselect="appWrap.deactivate('ts')" disable="appWrap.disabled.ts || disableInHistory()">
      <div ng-controller="HistoricoTratamentoSementesCtrl">
        <div class="container-header">
          <div class="clearfix"></div>

          <div class="title text-center">
            <h2>
              <strong>TRATAMENTO <br>DE SEMENTES</strong>
            </h2>
          </div>
          <!-- Filtros -->
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn">
               {{period.periodo || 'Período'}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem" ng-repeat="periodo in filtroPeriodo">
                <a ng-click="setPeriodo(periodo, $event)" href="#">{{::periodo.descricao | capitalize}}</a>
              </li>
              <li role="menuitem">
                <a ng-click="openPeriodsFilter($event)" href="#">Customizado</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" ng-show="loadingCultivares">
            <span>
              <i class="pull-right fa fa-spinner fa-spin"></i>
            </span>
          </div>
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-show="!loadingCultivares">
            <button type="button" class="btn">
               {{tsFilters.cultivar.descricao || 'Cultivar' | characters:15}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem" ng-show="tsFilters.cultivar">
                <a ng-click="setFilterAttribute('cultivar', null, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="cultivar in cultivares track by $index">
                <a ng-click="setFilterAttribute('cultivar', cultivar, $event)" href="#">{{cultivar.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-if="exibirPainelErrosIntegracao">
            <button type="button" class="btn">
               {{getStatusFilterLabel()}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right status-filter-menu" uib-dropdown-menu role="menu">
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.integrado}">
                <a ng-click="toggleStatusFilter('integrado', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.integrado ? 'fa-check-square-o' : 'fa-square-o'"></i> Integrados
                </a>
              </li>
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.erro}">
                <a ng-click="toggleStatusFilter('erro', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.erro ? 'fa-check-square-o' : 'fa-square-o'"></i> Erro
                </a>
              </li>
              <li role="menuitem" class="status-filter-item" ng-class="{active: statusFilter.pendente}">
                <a ng-click="toggleStatusFilter('pendente', $event)" href="#">
                  <i class="fa" ng-class="statusFilter.pendente ? 'fa-check-square-o' : 'fa-square-o'"></i> Pendentes
                </a>
              </li>
            </ul>
          </div>

        <!-- Fim Filtros -->
        </div>

        <div class="container-body width-100" ng-include="'views/painel_propriedade/_accordion_ts.html'"></div>
    </uib-tab>
  </uib-tabset>
</div>

<script type="text/ng-template" id="tooltip-pendente.html">
  <div class="text-center">
    Aguardando sincronização com o AgroGestão
  </div>
</script>

<script type="text/ng-template" id="tooltip-erro-integracao.html">
  <div class="text-center">
    Erro de integração com o AgroGestão
  </div>
</script>

<script type="text/ng-template" id="status-icons.html">
  <span ng-if="application.pendente"
        class="aplicacao-pendente-icon"
        tipped tipped-template="tooltip-pendente.html">
    <i class="fa fa-exclamation-triangle"></i>
  </span>
  <span ng-if="application.erro"
        class="aplicacao-erro-icon"
        tipped tipped-template="tooltip-erro-integracao.html">
    <i class="fa fa-exclamation-triangle"></i>
  </span>
</script>

<script type="text/ng-template" id="tooltip-data.html">
  <div class="text-center">
    <div>Aplicação fora da data</div>
    Prevista:
    <strong>
      {{::application.recomendacao_datas.data_inicio | date:'dd/MM/yy'}}
      <span ng-show="application.recomendacao_datas.data_inicio != application.recomendacao_datas.data_termino">
        a {{::application.recomendacao_datas.data_termino | date:'dd/MM/yy'}}
      </span>
    </strong>
  </div>
</script>

<script type="text/ng-template" id="datas-aplicacao.html">
  <div ng-hide="application.recomendacao_datas.aplicacao_fora_previsto" class="text-cinza">
    <i class="fa fa-calendar"></i>
    {{::application.dt_ini | date:'dd/MM/yy'}}
    <span ng-show="application.dt_ini != application.dt_fim">à {{::application.dt_fim | date:'dd/MM/yy'}}</span>
  </div>

  <div ng-show="application.recomendacao_datas.aplicacao_fora_previsto" class="text-danger" tipped tipped-template="tooltip-data.html">
    <i class="fa fa-info-circle"></i>
    {{::application.dt_ini | date:'dd/MM/yy'}}
    <span ng-show="application.dt_ini != application.dt_fim">à {{::application.dt_fim | date:'dd/MM/yy'}}</span>
  </div>
</script>

<script type="text/ng-template" id="data-ts.html">
  <div class="text-cinza">
    <i class="fa fa-calendar"></i>
    {{::application.data_hora_inicio | date:'dd/MM/yy'}}
    <span ng-show="application.data_hora_inicio != application.data_hora_fim">à {{::application.data_hora_inicio | date:'dd/MM/yy'}}</span>
  </div>
</script>
